import createMessage from "./createMessage";
import BatteryStatus from "../private/BatteryStatus";

const name = "batteryStatus";

function create({ state, level }) {
  return createMessage({
    [name]: BatteryStatus.create({ state, level })
  });
}

export default {
  create,
  name
};

// message BatteryStatus {
//     enum BatteryState {
//         CHARGING = 0;
//         FULL = 1;
//         DISCHARGING = 2;
//         UNKNOWN = 3;
//     }
//     BatteryState state = 1;
//     float level = 2;
// }
